import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { HrGetPersonPathParameters } from 'api/actions/hr-get-person/hr-get-person-path-parameters';
import { HrGetPersonResponse } from 'api/actions/hr-get-person/hr-get-person-response';

type HrGetPersonQueryParameters = Record<string, any>;

/**
 * The path of the HrGetPerson action.
 */
export const hrGetPersonActionPath = new SweetPath<keyof HrGetPersonPathParameters>('/api/hr/people/{personId}', {
  path: '{param}',
});

/**
 * Creates a contextualized HrGetPerson actions.
 */
export default function createHrGetPersonAction(axios: AxiosInstance) {
  return function hrGetPersonAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: HrGetPersonPathParameters;
    query?: HrGetPersonQueryParameters;
  }) {
    const path = hrGetPersonActionPath.insert(parameters);

    return axios.request<HrGetPersonResponse, HrGetPersonResponse>({
      method: 'get',
      url: path,
      params: query,

      headers,
    });
  };
}
